import { Howl, Howler } from 'howler'
let dropTickSource, positiveWinSoundSource, firstDropSource, bgMusicSource, betPlacedSource;
let prevGameMusic = null
import { path } from "./settings.js";
import store from 'redux-store/store.js';

export function loadSounds () {
   Howler.volume(0.1);

  firstDropSource = new Howl({
    src: [path.audioPath + 'first-drop.wav'],
    volume: 1
  });

  dropTickSource = new Howl({
    src: [path.audioPath + 'progressive-tick.wav'],
    volume: 1
  });

  positiveWinSoundSource = new Howl({
    src: [path.audioPath + 'win-sound.wav'],
    volume: 1
  });

  bgMusicSource  = new Howl({
    src: [path.audioPath + 'plinko-music.mp3'],  // ← your bg music file name
    loop: true,
    volume: 0.4                               // ← keep low so it doesn't overpower effects
  });

  betPlacedSource = new Howl({
    src: [path.audioPath + 'bet-place.mp3'],
    volume: 1
  });

  console.log("Audio Loaded");
}

export function initMusicListener() {
  store.subscribe(() => {
    const gameMusic = store.getState()?.gameSetting.gameMusic
    if (gameMusic !== prevGameMusic) {
      prevGameMusic = gameMusic
      gameMusic ? bgMusicSource?.play() : bgMusicSource?.pause()
    }
  })
}

export function toggleBgMusic () {
  const gameMusic = store.getState()?.gameSetting.gameMusic
  if (!bgMusicSource) return

  gameMusic ? bgMusicSource.play() : bgMusicSource.pause()
}

export function playBgMusic () {
  const gameMusic = store.getState()?.gameSetting.gameMusic
  gameMusic && bgMusicSource?.play()
}

export function pauseBgMusic () {
  bgMusicSource?.pause()
}

export function playFirstDropSound () {
  const gameSound = store.getState()?.gameSetting.gameSound
  gameSound && firstDropSource.play();
}

export function playDropTickSound () {
  const gameSound = store.getState()?.gameSetting.gameSound
  gameSound && dropTickSource.play();
}

export function playPositiveWinSound () {
  const gameSound = store.getState()?.gameSetting.gameSound
  gameSound && positiveWinSoundSource.play();
}

export function playbetPlacedSound () {
  const gameSound = store.getState()?.gameSetting.gameSound
  gameSound && betPlacedSource.play();
}


export function VolumeController (volume) {
  if(dropTickSource && positiveWinSoundSource && firstDropSource && betPlacedSource) {
    firstDropSource.volume(volume);
    dropTickSource.volume(volume);
    positiveWinSoundSource.volume(volume);
    betPlacedSource.volume(volume);
  }
}

export function setBgMusicVolume (volume) {
  bgMusicSource?.volume(volume)
}
